import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@/shared/ui/select';
import { ReceivableStatus } from '../../utils/types';
import { DateRange } from 'react-day-picker';
import { DateRangePicker } from '@/shared/widgets/DateRangePicker';
import { useTranslation } from '@/shared/i18n';

interface Props {
  search: string;
  onSearchChange: (value: string) => void;
  statusFilter: ReceivableStatus | 'all';
  onStatusFilterChange: (value: ReceivableStatus | 'all') => void;
  dateReferenceRange?: DateRange;
  onDateReferenceRangeChange?: (range: DateRange | undefined) => void;
  paidDateRange?: DateRange;
  onPaidDateRangeChange?: (range: DateRange | undefined) => void;
}

export function ReceivableFilters({
  search,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  dateReferenceRange,
  onDateReferenceRangeChange,
  paidDateRange,
  onPaidDateRangeChange,
}: Props) {
  const { t } = useTranslation('receivables');
  return (
    <div className="flex flex-col gap-4 w-full md:flex-row md:items-center">
      {/* Status */}
      <Select
        value={statusFilter}
        onValueChange={v => onStatusFilterChange(v as ReceivableStatus | 'all')}
      >
        <SelectTrigger className="w-full md:w-[160px]">
          <SelectValue placeholder={t('status')} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{t('allStatuses')}</SelectItem>
          <SelectItem value={ReceivableStatus.WAITING}>{t('waiting')}</SelectItem>
          <SelectItem value={ReceivableStatus.RECEIVED}>{t('received')}</SelectItem>
          <SelectItem value={ReceivableStatus.CONCLUDED}>{t('concluded')}</SelectItem>
          <SelectItem value={ReceivableStatus.CALCULATING}>{t('calculating')}</SelectItem>
          <SelectItem value={ReceivableStatus.CALCULATED}>{t('calculated')}</SelectItem>
          <SelectItem value={ReceivableStatus.FAIL}>{t('fail')}</SelectItem>
        </SelectContent>
      </Select>
      {/* Data de referência */}
      {typeof onDateReferenceRangeChange === 'function' && (
        <div className="w-full md:w-[280px]">
          <DateRangePicker
            dateRange={dateReferenceRange}
            setDateRange={onDateReferenceRangeChange}
            placeholder={t('referenceDateRange')}
          />
        </div>
      )}
      {typeof onPaidDateRangeChange === 'function' && (
        <div className="w-full md:w-[280px]">
          <DateRangePicker
            dateRange={paidDateRange}
            setDateRange={onPaidDateRangeChange}
            placeholder={t('paidDateRange')}
          />
        </div>
      )}
    </div>
  );
}
